import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { GaService } from 'src/app/core/helpers/ga.service';
import { RecaptchaComponent } from 'ng-recaptcha';
import { DeviceFingerprintService } from 'src/app/core/helpers/device-fingerprint.service';
import { LegalModalsService } from '../shared/services/legal-modals.service';

@Component({
  selector: 'loyaltic-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  Email = '';
  Name = '';
  isLoggedIn = false;
  hasOptedForMarkettingEmail = false;
  IsAcceptTerms = false;
  siteKey = "6LfD1hYsAAAAAGjk6Jx6Vyy5tHHiq6brYSrwuU2L";
  token: string = '';
  fingerprint: string = '';
  userId = '';
  IsUserAlreadyLoggedIn = false;

  @ViewChild('invisible', { static: false }) invisibleCaptcha: ElementRef<RecaptchaComponent>;

  constructor(public translate: TranslateService,
      private router: Router, private coreService: CoreService,
      private authService: AuthService,
      private gaService: GaService,
      private fp: DeviceFingerprintService,
      private legalModalsService: LegalModalsService,
      private toastr: ToastrService) { }

  async ngOnInit() {
    this.fingerprint = await this.fp.getFingerprint();
    this.userId = this.authService.getUserId();
    if (this.userId) {
      this.IsUserAlreadyLoggedIn = true;
      this.Email = localStorage.getItem('email');
    }
  }

  public addTokenLog(message: string, token: string | null) {
    console.log("===toekn", token)
    this.token = token;
  }

  public onError() {
    console.log(`reCAHPTCHA errored;`);
  }

  onSubmit(form) {
    form.submitted = false;

    let FirstName = '';
    let LastName = '';
    let name = this.Name.split(' ');
    if (name.length < 2) {
      FirstName = name[0];
      LastName = '';
    } else {
      FirstName = name[0];
      LastName = name[1];
    }

    let body = {};
    
    body = { Email: this.Email, HasOptedForMarkettingEmail: this.hasOptedForMarkettingEmail, FirstName: FirstName, LastName: LastName, recaptchaToken: this.token, deviceFingerprint: this.fingerprint};

    this.coreService.registerWithEmail(body).then((response: any) => {
      localStorage.setItem('email', this.Email)
      //this.isStoreUser = response.result.isStoreUser;
      //this.authService.updateStoreUser(response.result.isStoreUser);
      //localStorage.setItem('isStoreUser', response.result.isStoreUser);

      this.gaService.emitEvent('registration', 'Register Screen');
      //this.gaService.emitEvent('registration', 'Register Screen');

      this.Email = '';
      //this.Password = '';
      if (response.result.IsBannedForCheating) {
        this.authService.resetTokens();
        this.router.navigate(['/blocked']);
        return;
      }

      this.authService.updateAuthentication(true);

      this.authService.setToken(response.result.token, response.result.id);
      if (!response.result.nickNameExists) {
        localStorage.removeItem('hasAvatarImage');
        this.router.navigate(['capturenickname']);
      } else {
          localStorage.setItem('nickNameExists', 'true')
        localStorage.setItem('gameurl', response.result.gameurl);
        this.router.navigate(['captureImage']);
          
      }
    }, (error:any) => {
      console.log("=error", error)
      this.toastr.error(this.translate.instant(error.error.messageKey), this.translate.instant('error'))
    });
  }

  openRulesModal() {
    this.legalModalsService.openRules();
  }

  openPolicyModal() {
    this.legalModalsService.openPolicy();
  }

}
